import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45584cc6")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("ul", null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
      return (_openBlock(), _createBlock("li", {
        onClick: ($event: any) => (_ctx.choose(item)),
        class: _ctx.active == item.key ? 'active' : '',
        key: item
      }, _toDisplayString(item.label), 11, ["onClick"]))
    }), 128))
  ]))
})